import { authApi } from "./index";

export const getProviderProfile = async (providerId) => {
  try {
    const response = await authApi.get(`/Providers/${providerId}`);
    return response.data.data || response.data;
  } catch (error) {
    console.error(`Failed to load profile for provider ${providerId}:`, error);
    throw error;
  }
};

export const getProviderOfferings = async (providerId, params = {}) => {
  try {
    const response = await authApi.get(`/Providers/${providerId}/Offerings`, { params });
    return response.data.data || response.data;
  } catch (error) {
    console.error(`Failed to load offerings for provider ${providerId}:`, error);
    throw error;
  }
};

export const getProviderReviews = async (providerId, params = {}) => {
  try {
    const response = await authApi.get(`/Providers/${providerId}/Reviews`, { params });
    return response.data.data || response.data;
  } catch (error) {
    console.error(`Failed to load reviews for provider ${providerId}:`, error);
    throw error;
  }
};
